var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhitePaste({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 0V1.33333H11.3333C11.7013 1.33333 12 1.632 12 2V12.6667C12 13.0347 11.7013 13.3333 11.3333 13.3333H0.666667C0.298667 13.3333 0 13.0347 0 12.6667V2C0 1.632 0.298667 1.33333 0.666667 1.33333H2.66667V0H9.33333ZM2.66667 2.66667H1.33333V12H10.6667V2.66667H9.33333V4H2.66667V2.66667ZM6.66667 6V7.33333H8V8.66667H6.666L6.66667 10H5.33333L5.33267 8.66667H4V7.33333H5.33333V6H6.66667ZM8 1.33333H4V2.66667H8V1.33333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitePaste);
export default __webpack_public_path__ + "static/media/white-paste.3ec3202e09ac1bddcf13c13cb9ceb567.svg";
export { ForwardRef as ReactComponent };